// extracted by mini-css-extract-plugin
module.exports = {"tip":"_2P6Hj","p":"_2-rcW"};